
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Kohlapurtomumbai() {



  const cardData =
  {
    keyword: 'Kolhapur to Mumbai Cab',
    heading: 'SHREE Tours & Travels: Kolhapur to Mumbai Cab',
    headingDescription: 'SHREE Tours & Travels offers a dependable Kolhapur to Mumbai Cab service, ensuring a smooth and comfortable journey. Whether you are traveling for business, leisure, or a return trip home, our well-maintained Cabs and professional drivers provide a hassle-free experience. With on-time pickups, flexible booking options and affordable fares, we guarantee a safe and convenient ride. Choose SHREE Tours & Travels for a stress-free Kolhapur to Mumbai travel experience.',

    top: 'Top Places to Visit in Mumbai  with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is Mumbai’s most iconic landmark, built in 1924 to commemorate King George V and Queen Mary’s visit to India. Overlooking the Arabian Sea, this grand structure serves as a major tourist attraction. Visitors can enjoy ferry rides to Elephanta Caves, watch the bustling city life and capture stunning photographs with the Taj Mahal Palace Hotel in the backdrop. The site is also a historical symbol of India’s colonial past and independence."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive, famously known as the 'Queen’s Necklace' due to its glittering streetlights at night, is a 3.6 km long boulevard along the Arabian Sea. The promenade is a favorite among locals and tourists alike for evening walks, cycling and enjoying breathtaking sunsets. The cool sea breeze, coupled with street food like bhel puri and sev puri, makes it a perfect spot for relaxation. Marine Drive is also home to Art Deco buildings, adding to its charm."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus (CSMT) is one of Mumbai’s most stunning architectural marvels. Built in 1887, this Gothic-style railway station features Victorian-era influences, intricate carvings and beautiful stained-glass windows. It remains a busy hub for Mumbai’s lifeline – its railway network. Visitors can admire its grandeur during the day or witness its magnificent illumination at night."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, the Elephanta Caves are a UNESCO World Heritage Site featuring ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th-7th century and house mesmerizing sculptures, including the famous three-faced 'Trimurti' Shiva statue. The island also offers scenic trekking trails and panoramic views of Mumbai’s coastline."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its golden sands, vibrant atmosphere and delicious street food. Visitors can enjoy horse rides, watch the sunset, or simply relax by the sea. The beach is also a hotspot for Bollywood celebrities, making it a must-visit for film enthusiasts. Local snacks like pav bhaji, vada pav and gola are a must-try for food lovers."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "The Siddhivinayak Temple is one of the most revered temples in Mumbai, dedicated to Lord Ganesha. Built in 1801, this temple attracts thousands of devotees, including Bollywood stars and politicians, seeking blessings. The temple’s grand architecture, intricate carvings and spiritual ambiance make it a must-visit religious site. Tuesdays witness the highest footfall as it is considered an auspicious day for Lord Ganesha’s worship."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Haji Ali Dargah is an iconic religious site in Mumbai, situated on a small islet off the coast of Worli. This 15th-century Islamic shrine, built in Indo-Islamic style, is dedicated to Pir Haji Ali Shah Bukhari, a Sufi saint. The dargah is accessible via a narrow causeway during low tide, offering a spiritual and scenic experience. The site is known for its peaceful atmosphere, qawwali performances and stunning views of the Arabian Sea."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is Mumbai’s ultimate shopping destination, known for its street markets, trendy boutiques and vibrant cafés. Visitors can explore an array of fashion accessories, handicrafts, antiques and souvenirs at bargain prices. The area is also home to historic landmarks like Regal Cinema and Leopold Café, making it a perfect blend of culture, shopping and dining."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "A rare forested retreat within a bustling metropolis, Sanjay Gandhi National Park is a haven for nature lovers and wildlife enthusiasts. Spread over 100 sq km, the park is home to diverse flora and fauna, including leopards, deer and over 270 species of birds. The park features scenic trekking trails, the Kanheri Caves and boating facilities, offering a refreshing escape from Mumbai’s urban chaos."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "The Bandra-Worli Sea Link is an engineering marvel that connects South Mumbai to the western suburbs. This Cable-stayed bridge, spanning 5.6 km, offers a stunning view of the Mumbai skyline, especially at night when it is beautifully illuminated. Driving across the sea link provides a seamless travel experience and is a symbol of Mumbai’s modernization and progress."
    }
],  
    
            
"services": [
    {
      "name": "Kolhapur to Mumbai Taxi",
      "description": "Travel comfortably with our Kolhapur to Mumbai taxi service. Our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Whether you're traveling for business or leisure, we offer a safe and reliable ride to Mumbai."
    },
    {
      "name": "Kolhapur to Mumbai Cab Service",
      "description": "Looking for a dependable Cab service from Kolhapur to Mumbai? We offer both one-way and round-trip options, with comfortable seating, experienced drivers and competitive rates to ensure a relaxed and timely journey."
    },
    {
      "name": "Kolhapur to Mumbai One-Way Taxi",
      "description": "Book a one-way taxi from Kolhapur to Mumbai for a convenient, cost-effective and comfortable travel option. Enjoy a smooth ride without any hidden charges or hassles."
    },
    {
      "name": "Kolhapur to Mumbai Round Trip Cab",
      "description": "Planning a round trip from Kolhapur to Mumbai? Our round-trip Cab service provides flexibility for your return journey, with well-maintained vehicles and experienced drivers for a pleasant and hassle-free experience."
    },
    {
      "name": "Affordable Kolhapur to Mumbai Cab",
      "description": "Get affordable Cab services from Kolhapur to Mumbai without compromising on comfort or quality. We offer budget-friendly options tailored to your travel needs, ensuring a cost-effective and safe ride."
    },
    {
      "name": "Private Taxi for Mumbai from Kolhapur",
      "description": "Book a private taxi from Kolhapur to Mumbai for a personalized travel experience. Enjoy privacy, comfort and a seamless journey that’s tailored to your schedule and preferences."
    },
    {
      "name": "Mumbai Tour from Kolhapur by Cab",
      "description": "Explore Mumbai from Kolhapur with our Cab service. We offer customized tours to help you discover the city's top attractions, while ensuring a comfortable and relaxing ride with our experienced drivers."
    },
    {
      "name": "Group Travel from Kolhapur to Mumbai",
      "description": "Traveling with a group? Our spacious Cabs are perfect for group travel from Kolhapur to Mumbai. Enjoy a comfortable and stress-free journey with ample space for luggage and seating for everyone."
    },
    {
      "name": "Book Kolhapur to Mumbai Car",
      "description": "Easily rent a car for your journey from Kolhapur to Mumbai. We offer a wide range of vehicles including sedans, SUVs and larger cars, ensuring a comfortable and convenient ride for every traveler."
    },
    {
      "name": "Kolhapur to Mumbai Cab Booking",
      "description": "Book your Cab from Kolhapur to Mumbai online for a quick, easy and reliable service. Our booking process is simple and ensures that you get a professional driver and a well-maintained vehicle for your journey."
    },
    {
      "name": "Kolhapur to Mumbai Road Trip",
      "description": "Plan a scenic road trip from Kolhapur to Mumbai with our reliable taxi service. Experience the joy of a comfortable ride through picturesque landscapes, with our professional drivers ensuring a smooth and enjoyable journey."
    },
    {
      "name": "Mumbai Sightseeing by Cab",
      "description": "Discover Mumbai's most iconic landmarks with our sightseeing Cab service. Our professional drivers will take you to all the must-visit locations, providing an informative and comfortable experience throughout your journey."
    },
    {
      "name": "Kolhapur to Mumbai Luxury Taxi",
      "description": "Indulge in luxury with our premium taxi service from Kolhapur to Mumbai. Choose from high-end vehicles like Innova Crysta or luxury sedans and enjoy a plush, comfortable and relaxing ride tailored to your needs."
    }
  ],
  "tableData": [
    ["- Kolhapur to Mumbai Taxi", "- Kolhapur to Mumbai Cab Service"],
    ["- Kolhapur to Mumbai One-Way Taxi", "- Kolhapur to Mumbai Round Trip Cab"],
    ["- Affordable Kolhapur to Mumbai Cab", "- Private Taxi for Mumbai from Kolhapur"],
    ["- Mumbai Tour from Kolhapur by Cab", "- Group Travel from Kolhapur to Mumbai"],
    ["- Book Kolhapur to Mumbai Car", "- Kolhapur to Mumbai Cab Booking"],
    ["- Kolhapur to Mumbai Road Trip", "- Mumbai Sightseeing by Cab"],
    ["- Kolhapur to Mumbai Luxury Taxi", ""]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable and Convenient Journey",
      "WhyChoosedescription": "Our Kolhapur to Mumbai Cab service offers a comfortable and convenient journey, allowing you to relax and enjoy the ride. With spacious seating, air-conditioning and a smooth driving experience, you can sit back and enjoy a stress-free trip from Kolhapur to Mumbai."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes from Kolhapur to Mumbai. They prioritize your safety, punctuality and comfort, ensuring a smooth ride with a focus on customer satisfaction every step of the way."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive and transparent pricing for your Kolhapur to Mumbai Cab ride. Our rates are budget-friendly with no hidden charges, ensuring you get the best value for your money while maintaining excellent service quality."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "Our fleet of vehicles is regularly maintained to ensure they are in top condition for your journey. From cleanliness to mechanical reliability, we ensure your vehicle is ready for a safe, smooth and comfortable ride from Kolhapur to Mumbai."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking your Kolhapur to Mumbai Cab is simple and fast with SHREE Tours & Travels. You can easily book online through our user-friendly platform, or you can contact our customer service team for assistance. We ensure a seamless and convenient booking process for your travel needs."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Kolhapur to Mumbai Cab service. Whether you need an early morning ride or a late-night pickup, our round-the-clock service ensures that we can accommodate your schedule, ensuring you travel when it's most convenient for you."
    },
    {
      "WhyChooseheading": "Local Insights and Recommendations",
      "WhyChoosedescription": "Our drivers are not only skilled at driving but also knowledgeable about the best routes and local culture between Kolhapur and Mumbai. They can share useful insights, recommend places to visit, or help you with dining and sightseeing tips along the way."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our priority. We are committed to ensuring your Kolhapur to Mumbai Cab ride is safe, comfortable and timely. With a focus on service excellence, we guarantee that your experience will be smooth, pleasant and hassle-free."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I book a Cab from Kolhapur to Mumbai?",
        answer: "You can easily book your Kolhapur to Mumbai Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Kolhapur to Mumbai route?",
        answer: "We offer a variety of vehicles for the Kolhapur to Mumbai journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Kolhapur to Mumbai inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Kolhapur to Mumbai?",
        answer: "Yes, we offer one-way rental options for your Kolhapur to Mumbai trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Kolhapur to Mumbai trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Kolhapur to Mumbai Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Kolhapur to Mumbai Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Kolhapur to Mumbai trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Kolhapur to Mumbai?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Kolhapur to Mumbai?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Kolhapur to Mumbai trip was very comfortable. The driver was punctual and the vehicle was spacious and well-maintained.',
        name: 'Mr. Rajesh Kulkarni',
    },
    {
        text: 'I had an excellent experience with SHREE Tours & Travels. The ride from Kolhapur to Mumbai was smooth and the driver was courteous and professional.',
        name: 'Miss. Pooja Reddy',
    }
];













  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Kolhapur to Mumbai Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/kolhapur-to-mumbai-cab.jpg",
    "https://shreetoursandtravels.in/img/mumbai-trip-cab.jpg"
  ],
  "priceRange": "₹3500 - ₹7000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/kolhapur-to-mumbai-cab-service",
    "priceCurrency": "INR",
    "price": 5000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 850
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Rajendra Patil"
      },
      "datePublished": "2024-12-10",
      "reviewBody": "The ride from Kolhapur to Mumbai was very comfortable and the driver was very professional. I had a great experience and would definitely recommend this service."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Suman Jadhav"
      },
      "datePublished": "2024-12-15",
      "reviewBody": "Smooth and hassle-free ride. The Cab was clean and the driver was knowledgeable about the route. Highly recommend for a comfortable journey."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Kolhapur to Mumbai Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 16.7047,  // Kolhapur latitude
      "longitude": 74.2434  // Kolhapur longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/kolhapur-to-mumbai-cab-service"
  },
  "keywords": "Kolhapur to Mumbai Taxi, Kolhapur to Mumbai Cab Service, Kolhapur to Mumbai One-Way Taxi, Kolhapur to Mumbai Round Trip Cab, Affordable Kolhapur to Mumbai Cab, Private Taxi for Mumbai from Kolhapur, Mumbai Tour from Kolhapur by Cab, Group Travel from Kolhapur to Mumbai, Book Kolhapur to Mumbai Car, Kolhapur to Mumbai Cab Booking, Kolhapur to Mumbai Road Trip, Mumbai Sightseeing by Cab, Kolhapur to Mumbai Luxury Taxi"
};





  return (
    <div>
      <GoogleAnalytics/>
   <Helmet>
  <title>Kolhapur to Mumbai Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Kolhapur to Mumbai Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Kolhapur to Mumbai Taxi, Kolhapur to Mumbai Cab Service, Kolhapur to Mumbai One-Way Taxi, Kolhapur to Mumbai Round Trip Cab, Affordable Kolhapur to Mumbai Cab, Private Taxi for Mumbai from Kolhapur, Mumbai Tour from Kolhapur by Cab, Group Travel from Kolhapur to Mumbai, Book Kolhapur to Mumbai Car, Kolhapur to Mumbai Cab Booking, Kolhapur to Mumbai Road Trip, Mumbai Sightseeing by Cab, Kolhapur to Mumbai Luxury Taxi" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/17.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Kohlapurtomumbai;